/* eslint-disable @typescript-eslint/no-explicit-any */
import { SearchFacetsListCodes } from '../../constants/Filters.constant';
import { RegionItemHelperType, SubRegionCountry, SubRegionStructure } from './RegionCardsWrapper.types';
import {
  countryParamURL,
  destinationParamURL,
  destinationRedirectURL,
  stateProvinceParamURL,
  submitSearchURL,
  destinationRegionURL,
  CANADA_REGION_CODE,
  MEXICO_REGION_CODE,
  CHINA_REGION_CODE,
  TAIWAN_REGION_CODE,
  MACAU_REGION_CODE,
  HONG_KONG_REGION_CODE,
  CHINA_LABEL_FOR_MAP,
  ASIA_AEM_CODE,
  ASIA_CODE,
  USA_CODE,
  AFRICA_CUSTOM_LABEL,
  ASIA_CUSTOM_LABEL,
  EUROPE_CUSTOM_LABEL,
  MIDDLE_EAST_CUSTOM_LABEL,
  SOUTH_AMERICA_CUSTOM_LABEL,
  CARIBBEAN_CUSTOM_LABEL,
  CENTRAL_AMERICA_CUSTOM_LABEL,
  AUSTRALIA_CUSTOM_LABEL,
  USA_CUSTOM_LABEL,
  CANADA_CUSTOM_LABEL,
  MEXICO_CUSTOM_LABEL,
  MIDDLE_EAST_CODE,
  SOUTH_AMERICA_CODE,
  CENTRAL_AMERICA_CODE,
  AUSTRALIA_CODE,
  brandsParamsURL,
  viewTypeParamsURL,
  ASIA_EXTRAS,
  ASIA_REGION_KEY,
} from '../../constants/RegionCard.constants';
import { RegionItemDataList, RegionItems, SubRegionItems } from './RegionCardsWrapper.types';
import { isGreaterChinaLocale } from '@marriott/shared/mi-helper-utils';
import { addSubDirectoryPrefix } from '../../utils/src/subDirectoryFunctions';

export const customSort = (locale: string) => (a: any, b: any) => {
  const code = isGreaterChinaLocale(locale) ? ASIA_CODE : USA_CODE;
  if (a?.code === code) {
    return -1;
  } else if (b?.code === code) {
    return 1;
  } else {
    return a?.code?.localeCompare(b?.code, 'en', { numeric: true, sensitivity: 'base' });
  }
};
export const changeRegionNames = (
  regionItem: RegionItemHelperType,
  unitedStatesLabel: string,
  australiaPILabel: string
) => {
  if (regionItem?.customLabel === USA_CUSTOM_LABEL) {
    return unitedStatesLabel;
  } else if (regionItem?.customLabel === AUSTRALIA_CUSTOM_LABEL) {
    return australiaPILabel;
  } else {
    return regionItem?.label;
  }
};
export const extractMarkerData = (
  data: any,
  selectedRegion: any,
  subRegionName: Array<any>,
  labelForChina: string,
  australiaPILabel: string,
  mexicoCode: string,
  canadaCode: string,
  australiaAndOceaniaLabel: string
) => {
  let results: any = [];
  data?.search?.properties?.searchByLocation?.facets?.forEach(
    (response: { type: { code: string }; buckets: any[] }) => {
      if (
        response?.type?.code === SearchFacetsListCodes?.state ||
        response?.type?.code === SearchFacetsListCodes?.country
      ) {
        if (response?.type?.code === SearchFacetsListCodes?.country) {
          response.buckets?.forEach(subResponse => {
            subRegionName?.forEach(item => {
              let regionName = Object.keys(item).length ? Object.keys(item)[0] : '';

              if (regionName === selectedRegion?.label && selectedRegion?.customLabel !== USA_CUSTOM_LABEL) {
                const isMexicoPresent = results?.findIndex((item: any) => {
                  return item?.code === MEXICO_REGION_CODE;
                });
                const isCanadaPresent = results?.findIndex((item: any) => {
                  return item?.code === CANADA_REGION_CODE;
                });
                if (
                  regionName.toUpperCase() === mexicoCode?.toUpperCase() &&
                  isMexicoPresent < 0 &&
                  selectedRegion?.count > 0
                ) {
                  results.push({
                    code: MEXICO_REGION_CODE,
                    label: selectedRegion?.label,
                    count: selectedRegion?.count,
                  });
                }
                if (
                  regionName.toUpperCase() === canadaCode?.toUpperCase() &&
                  isCanadaPresent < 0 &&
                  selectedRegion?.count > 0
                ) {
                  results.push({
                    code: CANADA_REGION_CODE,
                    label: selectedRegion?.label,
                    count: selectedRegion?.count,
                  });
                }
                if (regionName === australiaPILabel) {
                  regionName = australiaAndOceaniaLabel;
                }
                item?.[regionName]?.forEach((subRItem: SubRegionItems) => {
                  //below part of code is very specific to China , Honkgonk, Taiwan and Macau
                  if (
                    subResponse?.code === subRItem?.subRegionCode &&
                    selectedRegion?.customLabel !== USA_CUSTOM_LABEL
                  ) {
                    results.push({
                      code: subRItem?.subRegionCode,
                      label: subRItem?.subRegionTagTitle,
                      count: subResponse?.count,
                    });
                  }
                  // }
                });
              }
            });
          });
        } else {
          response.buckets?.forEach(subResponse => {
            subRegionName?.forEach(item => {
              const regionName = Object.keys(item).length ? Object.keys(item)[0] : '';

              if (regionName === selectedRegion?.label && selectedRegion?.customLabel === USA_CUSTOM_LABEL) {
                item?.[regionName]?.forEach((subRItem: SubRegionItems) => {
                  if (subResponse?.code === subRItem?.subRegionCode) {
                    results.push({
                      code: subRItem?.subRegionCode,
                      label: subRItem?.subRegionTagTitle,
                      count: subResponse?.count,
                    });
                  }
                  // }
                });
              }
            });
          });
        }
      }
    }
  );
  //below part of code is very specific to China , Honkgonk, Taiwan and Macau
  const newCountsObjectForChina = {
    count: 0,
    label: labelForChina ?? CHINA_LABEL_FOR_MAP,
    code: CHINA_REGION_CODE,
  };
  results = results?.filter((obj: { code: string; count: number }) => {
    if (
      [TAIWAN_REGION_CODE, MACAU_REGION_CODE, HONG_KONG_REGION_CODE, CHINA_REGION_CODE].includes(obj.code) &&
      selectedRegion?.code === ASIA_AEM_CODE
    ) {
      newCountsObjectForChina.count += obj.count;

      return false;
    }
    return true;
  });
  if (selectedRegion?.code === ASIA_AEM_CODE) {
    results.push(newCountsObjectForChina);
  }
  return results;
};

export const getRegionDataToStore = (
  regionName: RegionItems[],
  subRegionName: any,
  dataFromResponse: any,
  mexicoCode: string,
  canadaCode: string
) => {
  const regionDataToStore: RegionItemDataList = [];

  regionName?.forEach((item: RegionItems) => {
    let regionParsed = false;
    let customLabel = '';
    if (item.regionCode === AFRICA_CUSTOM_LABEL) {
      customLabel = AFRICA_CUSTOM_LABEL;
    } else if (item.regionCode === ASIA_CUSTOM_LABEL) {
      customLabel = ASIA_CUSTOM_LABEL;
    } else if (item.regionCode === EUROPE_CUSTOM_LABEL) {
      customLabel = EUROPE_CUSTOM_LABEL;
    } else if (item.regionCode === MIDDLE_EAST_CODE) {
      customLabel = MIDDLE_EAST_CUSTOM_LABEL;
    } else if (item.regionCode === SOUTH_AMERICA_CODE) {
      customLabel = SOUTH_AMERICA_CUSTOM_LABEL;
    } else if (item.regionCode === CARIBBEAN_CUSTOM_LABEL) {
      customLabel = CARIBBEAN_CUSTOM_LABEL;
    } else if (item.regionCode === CENTRAL_AMERICA_CODE) {
      customLabel = CENTRAL_AMERICA_CUSTOM_LABEL;
    } else if (item.regionCode === AUSTRALIA_CODE) {
      customLabel = AUSTRALIA_CUSTOM_LABEL;
    } else if (item.regionCode === USA_CODE) {
      customLabel = USA_CUSTOM_LABEL;
    }
    subRegionName?.subRegion?.forEach((subRArray: { [x: string]: any[] }) => {
      const regionKeyName = Object.keys(subRArray)?.[0];
      if (item?.regionTagTitle === regionKeyName) {
        let count = 0;
        let regionsDataFromResponse = [];
        if (item?.regionTagTitle?.toLowerCase() === canadaCode?.toLowerCase()) {
          regionsDataFromResponse = dataFromResponse?.search?.properties?.searchByLocation?.facets.filter(
            (bucket: { type: { code: string } }) => {
              return bucket.type.code === 'countries';
            }
          );
          regionsDataFromResponse?.[0]?.buckets?.forEach((specificItem: { code: string; count: number }) => {
            if (specificItem?.code === CANADA_REGION_CODE) {
              regionParsed = true;
              regionDataToStore.push({
                label: item?.regionTagTitle,
                count: specificItem?.count,
                code: item?.regionCode,
                customLabel: CANADA_CUSTOM_LABEL,
              });
            }
          });
        } else if (item?.regionTagTitle?.toLowerCase() === mexicoCode?.toLowerCase()) {
          regionsDataFromResponse = dataFromResponse?.search?.properties?.searchByLocation?.facets.filter(
            (bucket: { type: { code: string } }) => {
              return bucket.type.code === 'countries';
            }
          );
          regionsDataFromResponse?.[0]?.buckets?.forEach((specificItem: { code: string; count: number }) => {
            if (specificItem?.code === MEXICO_REGION_CODE) {
              regionParsed = true;
              regionDataToStore.push({
                label: item?.regionTagTitle,
                count: specificItem?.count,
                code: item?.regionCode,
                customLabel: MEXICO_CUSTOM_LABEL,
              });
            }
          });
        }
        subRArray[regionKeyName]?.forEach(subRItems => {
          if (item?.regionCode === USA_CODE) {
            regionsDataFromResponse = dataFromResponse?.search?.properties?.searchByLocation?.facets.filter(
              (bucket: { type: { code: string } }) => {
                return bucket.type.code === 'states';
              }
            );
          } else {
            regionsDataFromResponse = dataFromResponse?.search?.properties?.searchByLocation?.facets.filter(
              (bucket: { type: { code: string } }) => {
                return bucket.type.code === 'countries';
              }
            );
          }
          regionsDataFromResponse?.[0]?.buckets?.forEach(
            (subRItemsFromResponse: { code: any; count: number; label: string }) => {
              if (subRItemsFromResponse?.code === subRItems?.subRegionCode) {
                count += subRItemsFromResponse?.count;
              }
            }
          );
        });
        if (
          item?.regionTagTitle?.toLowerCase() !== canadaCode?.toLowerCase() &&
          item?.regionTagTitle?.toLowerCase() !== mexicoCode?.toLowerCase()
        ) {
          regionParsed = true;
          const regionLabel = item?.regionTagTitle;

          regionDataToStore.push({
            label: regionLabel,
            count: count,
            code: item?.regionCode,
            customLabel: customLabel,
          });
        }
      }
    });
    if (regionParsed === false) {
      regionDataToStore.push({
        label: item?.regionTagTitle,
        count: 0,
        code: item?.regionCode,
        customLabel: customLabel,
      });
    }
  });
  return regionDataToStore;
};
export const convertToDTTResponse = (bauHDResp: any) => {
  const tempbauHDResp = JSON.parse(JSON.stringify(bauHDResp));
  const dttHDResp = {
    search: {
      properties: {
        searchByLocation: tempbauHDResp.searchPropertiesByDestination,
      },
    },
  };
  return dttHDResp;
};
//function to call exit points URL from Hotel directory page
export const formatExitURL = (
  destinationCode: string,
  destinationName: string,
  regionCode: string,
  brandCode: string,
  isDestinationRedirect?: boolean,
  viewAllRedirect?: boolean
) => {
  let redirectURL = '';

  //call submitsearch url
  if (!isDestinationRedirect) {
    redirectURL = addSubDirectoryPrefix(submitSearchURL);
    //call destination specific submitSearch url
    if (!viewAllRedirect) {
      if (regionCode === 'united-states') {
        //call uited-states specific submitSearch url
        redirectURL =
          redirectURL +
          destinationParamURL +
          destinationCode +
          ', USA' +
          countryParamURL +
          'US' +
          stateProvinceParamURL +
          destinationCode +
          brandsParamsURL +
          brandCode?.toUpperCase() +
          viewTypeParamsURL +
          'map';
      } else {
        redirectURL =
          redirectURL +
          destinationParamURL +
          destinationName +
          countryParamURL +
          destinationCode +
          brandsParamsURL +
          brandCode?.toUpperCase() +
          viewTypeParamsURL +
          'map';
      }
    } else {
      //call region specific submitSearch url
      redirectURL =
        redirectURL +
        destinationParamURL +
        regionCode +
        destinationRegionURL +
        regionCode +
        brandsParamsURL +
        brandCode?.toUpperCase() +
        viewTypeParamsURL +
        'map';
    }
  } else {
    //call destination page url
    redirectURL = addSubDirectoryPrefix(destinationRedirectURL) + destinationName?.split(' ')?.join('-') + '.mi';
  }

  return redirectURL;
};

// import { logger } from '../index';

export const formatNumberByLocale = (numb: number | string, lang: string): string => {
  // const { log } = logger({})('formatNumberByLocale');
  // log.debug(
  //   `[PerfTesting][utils] Entering the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  // );
  const inputStr = numb ?? '';
  // convert input number to locale string according to the lang
  // const str = Number(inputStr).toLocaleString(lang || '');
  let str = '';
  switch (lang) {
    case 'ko-KR':
    case 'ja-JP':
    case 'it-IT':
    case 'fr-FR':
    case 'de-DE':
    case 'ru-RU':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2 });
      break;
    case 'pt-BR':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 3 });
      break;
    case 'es-ES':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2, useGrouping: true });
      break;
    case '':
    case undefined:
      str = Number(inputStr)?.toLocaleString();
      break;
    default:
      str = Number(inputStr)?.toLocaleString(lang || '');
      break;
  }
  // log.debug(
  //   `[PerfTesting][utils] Exiting the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  // );
  return str;
};

/**
 * Ensures Asia list contains Taiwan (TW), Macau (MO), and Hong Kong (HK).
 *
 * NOTE:
 * As of now, we are manually handling and pushing Taiwan, Macau, and Hong Kong
 * into the Asia list. In the long term, this should ideally be handled by the
 * SHOP team, since we are reusing their tags — or it should be fixed at the
 * response layer so the API returns these values consistently.
 */

/**
 * Mutates the provided structure to ensure Asia contains the required entries.
 * Returns the same reference for convenience (chainable).
 */
export function ensureAsiaExtrasInObject(structure: any): SubRegionStructure {
  // Ensure top-level container exists and is an array
  if (!structure || typeof structure !== 'object') {
    structure = {};
  }
  if (!Array.isArray(structure?.subRegion)) {
    structure.subRegion = [];
  }

  // Find the Asia bucket (object with key "Asia" whose value is an array)
  const asiaIndex = structure?.subRegion?.findIndex((entry: any) => entry && Array.isArray(entry?.[ASIA_REGION_KEY]));

  if (asiaIndex >= 0) {
    const asiaArray: SubRegionCountry[] = structure?.subRegion[asiaIndex][ASIA_REGION_KEY];
    const existingCodes = new Set(asiaArray.map(country => String(country?.subRegionCode || '').toUpperCase()));

    ASIA_EXTRAS.forEach(extraCountry => {
      const extraCode = String(extraCountry?.subRegionCode)?.toUpperCase();
      if (!existingCodes?.has(extraCode)) {
        asiaArray?.push(extraCountry);
        existingCodes?.add(extraCode);
      }
    });
  } else {
    // Asia not present — create it with the extras
    structure?.subRegion?.push({ [ASIA_REGION_KEY]: [...ASIA_EXTRAS] });
  }

  return structure as SubRegionStructure;
}

/**
 * Function creates compact format for a given number based on the locale
 *
 * @param numb | string | undefined
 * @param locale | string
 * @param compactFormatLiteral | any
 * @returns string
 */
